import $ from "jquery";

function getChildrensFromHTML(html) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  var element = $(doc.body);
  return element.contents().toArray();
}

export { getChildrensFromHTML };
